import {mapGetters, mapState} from 'vuex'
import _ from 'lodash'
import JSONbig from 'json-bigint'
const JSONBigString = JSONbig({ storeAsString: true })

export default {
  props: {
    service: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    controls: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      listOptions: [],
      tagOptions: [],
      optionsLoading:false,
      APIFieldsByList: [],
      APIFields: null
    }
  },

  methods: {
    async fetchAPIFieldsByList () {
      this.optionsLoading = true
      const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
      return await axios.get(`api/projects/${this.project.id}/auto-responders/${_.kebabCase(serviceName)}/custom-fields?listId=${this.config.form.api_list_or_tag[serviceName]}`)
        .then(({data}) => {
          this.APIFieldsByList = data.data
        })
        .finally(() => {
          this.optionsLoading = false
        })
    },
    async integrateMailService () {
      VEvent.fire('loader', true)

      await this.$store.dispatch('apiIntegration/integrateMailService', {
        ...this.service,
        auto_responder_id: this.service.id
      })
        .then(({data}) => {
          this.service.status = data.data.status
          this.mailAPIServices.forEach(el => {
            if (el.id === this.service.id) {
              el.client_secret = this.service.client_secret
              el.client_id = this.service.client_id
              el.status = this.service.status
            }
          })
          this.prepare()
          VEvent.fire('autoresponder-integrated', {
            ...this.service
          })
        })
        .finally(() => {
          VEvent.fire('loader', false)
        })
    },

    async deleteMailService () {
      VEvent.fire('loader', true)
      const data = {
        ...this.service,
        auto_responder_id: this.service.id
      }
      await this.$store.dispatch('apiIntegration/deleteMailService', data)
        .then(() => {
          const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
          this.service.status = false
          this.$emit('remove-integration')
          this.$delete(this.config.form.api_list_or_tag, serviceName)
          this.$emit('deleteResponder', this.service)
        })
        .finally(() => {
          VEvent.fire('loader', false)
        })
    },

    async fetchAPIFields () {
      this.optionsLoading = true
      const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
      await axios.get(`api/projects/${this.project.id}/auto-responders/${_.kebabCase(serviceName)}/custom-fields`)
        .then(({data}) => {
          this.APIFields = data.data
        })
        .finally(() => {
          this.optionsLoading = false
        })
    },

    async fetchList () {
      this.optionsLoading = true
      const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
      const url = `api/projects/${this.project.id}/auto-responders/${_.kebabCase(serviceName)}/lists?per_page=100`
      if (serviceName === 'MailerLite') {
        try {
          const { data } = await axios.get(url, { transformResponse: [(r) => r] })
          const parsed = JSONBigString.parse(data)
          const list = Array.isArray(parsed) ? parsed : parsed.data

          this.listOptions = Array.isArray(list)
            ? list.map(item => ({ ...item, id: String(item.id) }))
            : []
        } catch (err) {
          console.error('Failed to fetch lists', err)
          this.listOptions = []
        } finally {
          this.optionsLoading = false
        } 
      } else {
        try {
          const { data } = await axios.get(url)
          this.listOptions = data.data
        } catch (err) {
          console.error('Failed to fetch lists', err)
          this.listOptions = []
        } finally {
          this.optionsLoading = false
        }
      }
    },

    async fetchTags () {
      this.optionsLoading = true
      const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
      await axios.get(`api/projects/${this.project.id}/auto-responders/${_.kebabCase(serviceName)}/tags`)
        .then(({data}) => {
          this.tagOptions = data.data
        })
        .finally(() => {
          this.optionsLoading = false
        })
    },
    async prepare () {
      this.optionsLoading = true
      try {
        if (this.service.has_list) {
          await this.fetchList()
          const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name

          if (this.config.form.api_list_or_tag[serviceName]) {
            await this.fetchAPIFieldsByList()
          }
        } else {
          if (this.service.has_tag) {
            await this.fetchTags()
          }

          await this.fetchAPIFields()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.optionsLoading = false
      }
    }
  },

  computed: {
    ...mapState('editor', {
      globalStyles: state => state.globalStyles
    }),
    ...mapGetters('apiIntegration', {
      hasAPI: 'hasMailAPIService'
    }),
    ...mapState('apiIntegration', {
      mailAPIServices: state => state.mailAPIServices
    }),
    ...mapState('projects', {
      project: state => state.project
    }),

    fieldsForMapping () {
      return this.controls
    },

    list_id: {
      get () {
        const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
        if (this.config.form.api_list_or_tag[serviceName]) this.fetchAPIFieldsByList()
        return this.config.form.api_list_or_tag[serviceName] || null
      },
      set (val) {
        const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
        this.$set(this.config.form.api_list_or_tag, serviceName, val)
        this.prepare()
      }
    },
    tags_id: {
      get () {
        const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
        let val = this.config.form.api_list_or_tag[serviceName]

        if (val && val.length) {
          val = val.filter(val => val)
        }

        return val || null
      },
      set (val) {
        const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
        this.$set(this.config.form.api_list_or_tag, serviceName, val)
      }
    },
    custom_tags_id: {
      get () {
        const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
        let val = _.get(this.config.form.api_list_or_tag,`CustomTags.${serviceName}`) || []
        val = val.filter(v => Boolean(v))
        return val
      },
      set (val) {
        const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
        this.$set(this.config.form.api_list_or_tag, `CustomTags.${serviceName}`, val)
      }
    },
    mailAPIService () {
      const serviceName = this.service.name === 'Kit' ? 'Convert Kit' : this.service.name
      return _.find(this.mailAPIServices, ['name', serviceName])
    }
  },

  created () {
    if (this.mailAPIService?.status !== 'ACTIVE') return
    this.prepare()
  }
}
